export default __webpack_public_path__ + "static/media/users.657a0d03.svg";